import { Link } from "react-router-dom";

import { ProductCard } from "./ProductCard";
import { SectionHead } from "./SectionHead";

export const TodaysFinds = ({ onAdd, items }) => (
  <section id="todays-finds" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 scroll-mt-40" data-testid="todays-finds-section">
    <SectionHead eyebrow="Just landed" title="Fresh Finds!" text="A bit of everything: new, used and open-box, with every condition clearly labelled."
      action={<Link to="/shop" data-testid="see-all-link" className="text-sm font-bold text-[#202A35] underline underline-offset-4 hover:text-[#B87F00]">See everything →</Link>} />
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 sm:gap-4">
      {items.map((p) => <ProductCard key={p.id} p={p} onAdd={onAdd} />)}
    </div>
    {items.some((p) => p.demo) && <p className="mt-4 text-xs text-[#202A35]/55" data-testid="demo-stock-note">Items marked "Demo item" are examples, not real stock.</p>}
  </section>
);

export const OneOffFinds = ({ onAdd, items }) => (
  <section id="one-off-finds" className="bg-[#FFF3C4] scroll-mt-40" data-testid="one-off-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid lg:grid-cols-12 gap-8 items-center">
      <div className="lg:col-span-4">
        <span className="inline-block -rotate-2 bg-[#FF6B5B] text-white text-xs font-bold px-3 py-1 rounded-full mb-3">Once they're gone, they're gone</span>
        <SectionHead eyebrow="One-off items" title="Only One Left!"
          text="Individual items, open-box bargains and unexpected treasures. Blink and you'll miss them." />
        <p className="text-sm text-[#202A35]/60 -mt-6" data-testid="one-off-stock-note">Items marked "Demo item" are examples for this preview.</p>
      </div>
      <div className="lg:col-span-8 grid grid-cols-2 sm:grid-cols-3 gap-3 sm:gap-4">
        {items.map((p) => <ProductCard key={p.id} p={p} onAdd={onAdd} />)}
      </div>
    </div>
  </section>
);
